import { Heading } from "@chakra-ui/react"

import { useBitcoinDepositFromAnotherWallet } from "#/shared/hooks"
import ModalLeave from "#/ui-old/Modal/ModalLeave"

import DepositModalInsufficient from "./DepositModalInsufficient"
import DepositModalQR from "./DepositModalQR"
import DepositModalReceiptDetails from "./DepositModalReceiptDetails"

export default function DepositModalReceiptFromAnotherWallet({
  close,
  showClosingModal,
  setConfirmModalClose,
}: {
  close: () => void
  showClosingModal: boolean
  setConfirmModalClose: (value: boolean) => void
}) {
  const { bitcoinBridgeDepositAddres: bitcoinAddress, sentInsufficientFunds } =
    useBitcoinDepositFromAnotherWallet()

  if (showClosingModal) {
    return (
      <ModalLeave
        header="Leave deposit?"
        stayText="Stay, I'm depositing"
        leaveModalText="Leave, not depositing"
        onClose={close}
        backToProcessTrigger={() => setConfirmModalClose(false)}
      />
    )
  }

  if (sentInsufficientFunds) {
    return <DepositModalInsufficient />
  }

  return (
    <>
      <Heading variant="h3" textAlign="center" mb={8}>
        Send deposit
      </Heading>
      <DepositModalReceiptDetails />
      <DepositModalQR bitcoinAddress={bitcoinAddress} />
    </>
  )
}
